import React, {Component} from 'react';
import {Input, Grid} from 'react-spreadsheet-grid';
import set from 'lodash.set';
import Select, {components, DropdownIndicatorProps} from 'react-select'
import {Collapse} from 'react-collapse';
import {Button} from "react-bootstrap";
import arrow_up from "../../assets/icons/dark_arrow_up.png";
import arrow_down from "../../assets/icons/dark_arrow_down.png";
import {Typography} from "@material-ui/core";

export class FertilizersTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columnsRegion: [],
            update: false
        }
        this.calcSum=this.calcSum.bind(this)
        this.setUseInputPrice=this.setUseInputPrice.bind(this)
    }

    componentDidMount() {
        this.populateFieldsData();
    }
    calcSum(useInputPrice){
        let sum=0
        let fertilizer
        // eslint-disable-next-line array-callback-return
        this.props.field[0].regions.map((region)=>{
            fertilizer = this.props.fertilizers.find((f)=>f.id===region.fertilizerOrganicId)
            sum+=(useInputPrice?Number(region.organic_input_price):0)*Number(region.area)*region.fertilizerCount+
                (fertilizer? fertilizer.price:0)*region.fertilizerCount*Number(region.area)
        })
        this.props.setSumPrice(sum)
    }

    static renderTable(field, columnsRegion, expand, isExpand, useInputPrice, setUseInputPrice) {
        let row = field.length !== 0 ? field[0].regions : [];
        if (row.length !== 0) {
            return (
                <div id='fertilizer-table-container'>
                    <div className="label-btn-container">
                        <Button className="label-button" onClick={expand}>Органические удобрения под планируемую культуру
                            <img src={isExpand ? arrow_up : arrow_down} className='btn-arrow' alt='arrow'/>
                        </Button>
                    </div>
                    <Collapse isOpened={isExpand}>
                        <div id="fertilizers_table" className='input-price-cell'>
                            {/*<input className='input-price-checkbox' type='checkbox' checked={useInputPrice} onClick={setUseInputPrice}/>*/}
                            <Grid
                                columns={columnsRegion}
                                rows={row}
                                rowHeight={75}
                                focusOnSingleClick={true}
                                isColumnsResizable
                                getRowKey={row => row.id}
                                isScrollable={false}
                                disabledCellChecker={(row, columnId) => {
                                    return columnId === 'organic' ||
                                        columnId === 'price'
                                }}
                            />
                        </div>
                    </Collapse>
                </div>
            );
        } else
            return (<div></div>)
    }

    setUseInputPrice(){
        this.props.setUseInputPrice()
        this.calcSum(!this.props.useInputPrice)
    }

    render() {
        const content=FertilizersTable.renderTable(
            this.props.field,
            this.state.columnsRegion,
            this.props.changeExpand,
            this.props.expand,
            this.props.useInputPrice,
            this.setUseInputPrice
        )
        return (
            <div key={this.state.update}>{content}</div>
        );
    }

    async populateFieldsData() {
        // const useInputPrice = this.props.useInputPrice
        const numberFormat = new Intl.NumberFormat('ru-RU')
        const priceFormat = new Intl.NumberFormat('ru-RU',{maximumFractionDigits:2,minimumFractionDigits:2})
        function formatCell(value, price=false){
            return value?(price?priceFormat:numberFormat).format(value.toString().replace(',','.')).replace(',','.'):0
        }
        const fertilizers_organic_list = this.props.fertilizer_organic_list;
        const onRegionChange = (rowId, field) => (value1) => {
            let value = Number(value1.replace(/\s/g, "").replace(',','.'))
            const row = this.props.field[0].regions.find((row) => {
                return row.id === rowId;
            });
            set(row, field, value);
            this.props.onFertilizerChange();
            this.calcSum(this.props.useInputPrice)
            this.setState({update: !this.state.update})
        }
        const onFertilizerChange = (rowId, field) => (value) => {
            const row = this.props.field[0].regions.find((row) => {
                return row.id === rowId;
            });
            row.fertilizerOrganic = this.props.fertilizers.find((f) => {
                return f.id === value.value;
            })
            set(row, field, value.value);
            this.props.onFertilizerChange();
            this.calcSum(this.props.useInputPrice)
            this.setState({update: !this.state.update})
        }

        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет данных</Typography>;
        }
        const columnsRegion = [
            {
                title: 'Наим. эл. участка',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={row.name}
                            selectTextOnFocus={true}
                            focus={focus}
                            onChange={onRegionChange(row.id, 'name')}
                        />
                    )
                },
                id: 'name',
                width: 12
            }, {
                title: 'Площадь, га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.area == '0' ? 'no-data-cell' : 'data-cell'}>
                        <Input
                            value={formatCell(row.area)}
                            selectTextOnFocus={true}
                            focus={focus}
                            onChange={onRegionChange(row.id, 'area')}
                        />
                        </div>
                    )
                },
                id: 'area',
                width: 10
            }, {
                title: 'Тип органического удобрения',
                value: (row, {focus}) => {
                    return (
                        <Select
                            maxMenuHeight="235px"
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    margin: '10px',
                                    width: '95%',
                                    height: '53px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '53px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    height: '45px',
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                }),
                                singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '650px'
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar":{
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb":{
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover":{
                                        background: ' #ABB3D1 !important',
                                    }
                                })
                            }}
                            id="fertilizer-organic-select"
                            defaultValue={fertilizers_organic_list[fertilizers_organic_list.findIndex((r) => r.value === row.fertilizerOrganicId)]}
                            options={fertilizers_organic_list}
                            placeholder='Выберите удобрение'
                            onChange={onFertilizerChange(row.id, 'fertilizerOrganicId')}
                        />
                    )
                },
                id: 'organic',
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: 'Кол-во ОУ, т/га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.fertilizerCount == '0' ? 'no-data-cell' : 'data-cell'}>
                        <Input
                            value={formatCell(row.fertilizerCount)}
                            focus={focus}
                            selectTextOnFocus={true}
                            onChange={onRegionChange(row.id, 'fertilizerCount')}
                        />
                        </div>
                    );
                },
                id: 'fertilizerCount',
                width: 12
            }, {
                title: 'Стоимость удобрения, руб/поле',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell((this.props.fertilizers.find((f) => f.id === row.fertilizerOrganicId)?.price) * row.fertilizerCount * row.area, true)}
                            selectTextOnFocus={true}
                            focus={focus}
                        />
                    )
                },
                id: 'price',
                width: 15,
            }
            // }, {
            //     title: 'Стоимость внесения \nруб/т',
            //     value: (row, {focus}) => {
            //         return (
            //             <div className={''+(useInputPrice?'':'disable')}>
            //             <Input
            //                 value={formatCell(row.organic_input_price,true)}
            //                 focus={focus}
            //                 selectTextOnFocus={true}
            //                 onChange={onRegionChange(row.id, 'organic_input_price')}
            //             />
            //             </div>
            //         )
            //     },
            //     id: 'intro_price',
            //     width: 12,
            // }
        ];

        this.setState({columnsRegion: columnsRegion});
    }

}
